import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {

    clusterStats: {
        indices: {
            shards: {
                total: null
            },
        },
        nodes: {
            process: {
                cpu: {
                    percent: null,
                }
            },
            count: {
                total: null
            },
            versions: [
                'Unknown',
            ],
            os: {
                mem: {
                    free_in_bytes: null,
                    used_in_bytes: null,
                    free_percent: null,
                    used_percent: null,
                    total_in_bytes: null,
                },
                available_processors: null,
                allocated_processors: null,
            },
            fs: {
                available_in_bytes: null,
                free_in_bytes: null,
                total_in_bytes: null,
            },
        }
    },

    clusterStatsExpire: null,
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

